// extracted by mini-css-extract-plugin
export default {"my_btn":"CustomBtnTransparent_my_btn__sTzQc","arrow":"CustomBtnTransparent_arrow__Xn+Mf","arrow_rotated":"CustomBtnTransparent_arrow_rotated__V2Hz-"};